export const LEASE_LOAD_DAYS = 7;
export const DAYS_VISIBLE = 3;
